if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      next(e) {
        this.currentIndex += 1;
        if (this.currentIndex >= this.medias.length) this.currentIndex = 0;
        this.showActiveMedia();
      }

      prev() {
        this.currentIndex -= 1;
        if (this.currentIndex < 0) this.currentIndex = this.medias.length - 1;
        this.showActiveMedia();
      }

      showActiveMedia() {
        Array.from(this.medias).forEach(element => element.classList.remove('active'));
        const activeMedia = Array.from(this.medias).find((element, index) => index === this.currentIndex);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
